import AbhijayDas from '@/data/2024/assets/images/dev/Abhijay_Das.jpg'
import DaveKoziol from '@/assets/images/organizers/Dave_Koziol-x96.webp'
import Hisham_Odeh from '@/data/2024/assets/images/dev/Hisham_Odeh.jpg'
import Heba_Sayed from '@/data/2024/assets/images/dev/Heba_Sayed.jpg'
import HudaHussaini from '@/assets/images/facilitators/Huda_Hussaini-x96.webp'
import IrwinPatcharaput from '@/data/2024/assets/images/dev/Irwin_Patcharaput.jpeg'
import JennaRitten from '@/assets/images/organizers/Jenna_Ritten-x96.webp'
import JingranWang from '@/data/2025/assets/images/team/Jingran_Wang-x96.webp'
import JuanLinaresOrihuela from '@/assets/images/facilitators/Juan_Linares_Orihuela-x96.webp'
import MohamadAlabudi from '@/data/2024/assets/images/dev/Mohamad_Alabudi.jpg'
import RahulVarmaAlluri from '@/data/2024/assets/images/dev/Rahul_Varma_Alluri.jpg'
import SohanKetireddy from '@/data/2025/assets/images/team/sohan_ketireddy-x96.webp'
import SumiaSaleh from '@/data/2025/assets/images/team/Sumia_Saleh-x96.webp'
import TejasVaity from '@/data/2024/assets/images/dev/Tejas_Vaity.jpg'
import ZavaarShah from '@/assets/images/facilitators/Zavaar_Shah-x96.webp'

export const teamData = [
  {
    id: 1,
    name: 'Dave Koziol',
    twitter: 'davekoziol',
    linkedin: 'https://www.linkedin.com/in/davekoziol/',
    github: '',
    devfest: 'organizer',
    university: '',
    organization: 'Little Caesars',
    role: 'GDG Organizer',
    avatar: DaveKoziol,
  },
  {
    id: 2,
    name: 'Jenna Ritten',
    twitter: 'jritten',
    linkedin: 'https://gdg.community.dev/u/mbhdq6/',
    github: 'https://github.com/jritten',
    devfest: 'organizer',
    university: '',
    organization: 'IBM',
    role: 'GDG Organizer',
    avatar: JennaRitten,
  },
  {
    id: 3,
    name: 'Huda Hussaini',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/huda-hussaini/',
    github: '',
    devfest: 'facilitator',
    university: 'University Of Michigan Dearborn',
    bio: `Integrating AI and cybersecurity testing for automotive vehicles at ETAS.`,
    organization: 'ETAS',
    role: 'Cybersecurity Software Engineer',
    avatar: HudaHussaini,
  },
  {
    id: 4,
    name: 'Juan Linares Orihuela',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/juanlinaresorihuela/',
    github: '',
    devfest: 'facilitator',
    university: 'Georgia Institute of Technology',
    bio: `After transitioning into tech, I became a software engineer driven by a passion for using data to solve problems and build innovative software. As I pursue my Master’s in Data Analytics at Georgia Tech, I continually seek new opportunities to learn and make a meaningful impact in the tech world.`,
    organization: '',
    role: 'Software Engineer ',
    avatar: JuanLinaresOrihuela,
  },
  {
    id: 5,
    name: 'Zavaar Shah',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/zavaar-shah/',
    github: '',
    devfest: 'facilitator',
    university: 'Wayne State University',
    bio: `Hey I'm Zavaar! I'm a student at Wayne State University currently doing my bachelors and masters in Computer Science.`,
    organization: 'GE Aerospace',
    role: 'Software Engineering Intern',
    avatar: ZavaarShah,
  },
  {
    id: 6,
    name: 'Jingran Wang',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/jingranwang/',
    github: '',
    devfest: 'facilitator',
    university: 'University Of Michigan Dearborn',
    bio: `Experienced community organizer, including co-organizing GDG Ann Arbor. Android/Flutter Developer passionate about UX, readable, shippable code, accessibility, and teamwork.`,
    organization: 'Hikari Software',
    role: 'President',
    avatar: JingranWang,
  },
  {
    id: 7,
    name: 'Sumia Saleh',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/sumia-saleh/',
    github: '',
    devfest: 'facilitator',
    university: 'University Of Michigan Dearborn',
    bio: ``,
    organization: 'University of Michigan Dearborn',
    role: 'GDSC',
    avatar: SumiaSaleh,
  },
  {
    id: 8,
    name: 'Hisham Odeh',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/hisham-odeh-4611081b0',
    github: 'https://github.com/Heshoo-ksh',
    university: 'University Of Michigan - Dearborn',
    organization: 'Ancor Automotive',
    position: 'Junior Software Engineer And Student',
    avatar: Hisham_Odeh,
    devfest: 'devteam',
  },
  {
    id: 9,
    name: 'Mohamad Alabudi',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/malabudi',
    github: 'https://malabudi.github.io/',
    avatar: MohamadAlabudi,
    university: 'University of Michigan Dearborn',
    organization: '',
    position: 'Student',
    devfest: 'devteam',
  },
  {
    id: 10,
    name: 'Heba Sayed',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/heba-sayed6/',
    github: 'https://github.com/hebz26',
    university: 'University Of Michigan Dearborn',
    organization: '',
    position: 'Student',
    avatar: Heba_Sayed,
    devfest: 'devteam',
  },
  {
    id: 11,
    name: 'Rahul Varma Alluri',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/rahul-alluri/',
    github: 'https://github.com/RahulAlluriUmd',
    university: 'University Of Michigan Dearborn',
    organization: '',
    position: 'Graduate Student',
    avatar: RahulVarmaAlluri,
    devfest: 'devteam',
  },
  {
    id: 12,
    name: 'Tejas Vaity',
    bio: '',
    linkedin: 'www.linkedin.com/in/tejas-vaity-832972147',
    github: 'https://github.com/Tej619',
    university: 'University of Michigan Dearborn',
    organization: '',
    position: 'Graduate Student',
    avatar: TejasVaity,
    devfest: 'devteam',
  },
  {
    id: 13,
    name: 'Juan Linares Orihuela',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/juanlinaresorihuela/',
    github: 'https://github.com/JuanLinaresOrihuela',
    university: 'Georgia Institute of Technology',
    organization: '',
    position: 'Software Engineer - Graduate Student',
    avatar: JuanLinaresOrihuela,
    devfest: 'devteam',
  },
  {
    id: 14,
    name: 'Abhijay Das',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/abhijaydas/',
    github: 'https://github.com/abhijaythethinker',
    university: 'University Of Michigan Dearborn',
    organization: '',
    position: 'Student',
    avatar: AbhijayDas,
    devfest: 'devteam',
  },
  {
    id: 15,
    name: 'Sohan Ketireddy',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/sohan-k',
    github: 'https://github.com/sohank1',
    university: 'University Of Michigan Dearborn',
    organization: '',
    position: 'Student',
    avatar: SohanKetireddy,
    devfest: 'devteam',
  },
  {
    id: 16,
    name: 'Irwin Patcharaput',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/irwinpatcharaput/',
    github: 'https://github.com/irwinpp',
    university: 'University Of Michigan Dearborn',
    organization: '',
    position: 'Student',
    avatar: IrwinPatcharaput,
    devfest: 'devteam',
  },
]
